import { render, staticRenderFns } from "./StockBollingerView.vue?vue&type=template&id=450bceef&scoped=true"
import script from "./StockBollingerView.vue?vue&type=script&lang=js"
export * from "./StockBollingerView.vue?vue&type=script&lang=js"
import style0 from "./StockBollingerView.vue?vue&type=style&index=0&id=450bceef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450bceef",
  null
  
)

export default component.exports